import React from "react";
import { Message } from "./MessageList";

interface ReplyModalProps {
  show: boolean;
  replyMessage: Message;
  replyText: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSaveReply: () => void;
  onCancel: () => void;
  onSubmit: () => void;
}

const ReplyModal: React.FC<ReplyModalProps> = ({
  show,
  replyMessage,
  replyText,
  onChange,
  onSaveReply,
  onCancel,
  onSubmit,
}) => {
  if (!show) return null;

  const handleLocalSaveReply = () => {
    console.log("ReplyModal: Save and Resume Reply button clicked");
    onSaveReply();
  };

  const handleLocalCancel = () => {
    console.log("ReplyModal: Cancel button clicked");
    onCancel();
  };

  const handleLocalSubmit = () => {
    console.log("ReplyModal: Submit button clicked");
    onSubmit();
  };

  return (
    <div style={modalOverlayStyle} role="dialog" aria-modal="true">
      <div style={modalDialogStyle}>
        <div className="govuk-modal__header">
          <h2 className="govuk-modal__title">Reply</h2>
        </div>
        <div className="govuk-modal__body">
          <p style={{ fontStyle: "italic", marginBottom: "1rem" }}>
            Original message: {replyMessage.messageText}
          </p>
          <textarea
            style={{ width: "100%", minHeight: "100px", marginBottom: "1rem" }}
            value={replyText}
            onChange={onChange}
          />
          <div
            className="govuk-button-group"
            style={{
              marginTop: "1rem",
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
            }}
          >
            <button type="button" className="govuk-button govuk-button--secondary" onClick={handleLocalSaveReply}>
              Save and Resume Reply
            </button>
            <button type="button" className="govuk-button govuk-button--secondary" onClick={handleLocalCancel}>
              Cancel
            </button>
            <button type="button" className="govuk-button" onClick={handleLocalSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const modalOverlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalDialogStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  padding: "1rem",
  borderRadius: "4px",
  maxWidth: "800px",
  width: "90%",
  maxHeight: "90vh",
  overflowY: "auto",
};

export default ReplyModal;
